import React from "react";

const BolgView = (props) => {
  const {
    loadingCallback,
    navigate,
    setShowPaymentModal,
    setShowModal,
    isOpen,
    title,
    //setWarningMessage,
    type,
    formData,
    setFormData,
    coupon,
  } = props;
  return (
    <div className="duration-500 w-[3/4] h-[3/4]">
      {console.log("coupon", coupon)}
      <div className="w-full flex flex-col pl-5">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Name
        </label>
        <sapn className="font-normal text-xs">{coupon.coupon_name}</sapn>
      </div>

      <div className="w-full flex flex-col pl-5 mt-3">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Coupon Code
        </label>
        <sapn className="font-normal text-xs">{coupon.coupon_code}</sapn>
      </div>

      <div className="w-full flex flex-col pl-5 mt-3">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Amount
        </label>
        <sapn className="font-normal text-xs">{coupon.amount}</sapn>
      </div>

      <div className="w-full flex flex-col pl-5 mt-3">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Usage Limit
        </label>
        <sapn className="font-normal text-xs">{coupon.usage_limit}</sapn>
      </div>

      <div className="w-full flex flex-col pl-5 mt-3">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Used Count
        </label>
        <sapn className="font-normal text-xs">{coupon.used_count}</sapn>
      </div>

      <div className="w-full flex flex-col mt-3 pl-5">
        <span className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Active Status
        </span>
        <span className="font-normal text-xs">
          <div className="text-left">
            {coupon.used_count === coupon.usage_limit ? (
              <span className="text-red-500 font-semibold">Limit Reached</span>
            ) : new Date(coupon.expire_date) < new Date() ? (
              <span className="text-red-500 font-semibold">Expired</span>
            ) : (
              <span className="text-green-600 font-semibold">Active</span>
            )}
          </div>
        </span>
      </div>

      <div className="w-full flex flex-col pl-5 mt-3">
        <label className="font-nunito text-xs text-[#102048] bg-white  font-semibold">
          Expire Date
        </label>
        <sapn className="font-normal text-xs">{new Date(coupon.expire_date).toISOString().split("T")[0]}</sapn>
      </div>

      <div className="w-full flex flex-col mt-3 pl-5">
        <label className="font-nunito text-xs text-[#102048] bg-white font-semibold">
          Description
        </label>
        <p className="font-normal text-xs max-h-[800px] overflow-auto">{coupon.description}</p>
      </div>
    </div>
  );
};

export default BolgView;
